var _POSITION_ALIGNMENTS;

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    width: ", ";\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    width: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: ", "px;\n  box-shadow: ", ";\n  display: inline-flex;\n  min-height: ", "px;\n  max-width: ", ";\n  animation: ", " 300ms ease-in-out;\n  animation-fill-mode: both;\n  & > * {\n    width: 100%;\n  }\n  ", ";\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(", "px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Breakpoints, Inset, Media, Shadows, Spacing, withTheming } from '@doordash/design-language';
import styled, { keyframes } from 'styled-components';
import { POSITIONS } from './constants';
var DESKTOP_SIZE = Breakpoints.Mobile;
var MAX_WIDTH = "calc(100vw - ".concat(Spacing.XxSmall * 2, "px)");
var slideAnimation = keyframes(_templateObject(), Spacing.Small);
var POSITION_ALIGNMENTS = (_POSITION_ALIGNMENTS = {}, _defineProperty(_POSITION_ALIGNMENTS, POSITIONS.BottomCenter, 'center'), _defineProperty(_POSITION_ALIGNMENTS, POSITIONS.TopCenter, 'center'), _defineProperty(_POSITION_ALIGNMENTS, POSITIONS.BottomStart, 'flex-start'), _defineProperty(_POSITION_ALIGNMENTS, POSITIONS.TopStartBottomStart, 'flex-start'), _defineProperty(_POSITION_ALIGNMENTS, POSITIONS.BottomEnd, 'flex-end'), _defineProperty(_POSITION_ALIGNMENTS, POSITIONS.TopEnd, 'flex-end'), _POSITION_ALIGNMENTS);
export var ToastContainer = styled.div(_templateObject2(), function (props) {
  return POSITION_ALIGNMENTS[props.position];
});
export var ToastContentContainer = withTheming(styled(Inset).attrs({
  size: Spacing.Large,
  isSquished: true
})(_templateObject3(), function (_ref) {
  var theme = _ref.theme;
  return theme.Colors.ToastInformationalBackground;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.BorderRadius.ToastContainer;
}, Shadows.Medium, Spacing.XxLarge, MAX_WIDTH, slideAnimation, Media.Desktop(_templateObject4(), function (_ref3) {
  var hasAction = _ref3.hasAction;
  return hasAction ? "".concat(DESKTOP_SIZE, "px") : 'auto';
}), Media.Mobile(_templateObject5(), function (_ref4) {
  var hasAction = _ref4.hasAction;
  return hasAction ? "".concat(MAX_WIDTH) : 'auto';
})));